import { Pole } from "../../../../types/planBT.types";
import Table from "../../../../../../common/components/molecule/Table/Table";


export interface PoleListViewProps {
  poleList?: Pole[] | null;
  isLoading?: boolean;
  error?: string | null;
  onPoleClick?: (poleId: string) => void;
  handleDelete?: (poleId: string) => void;
  handleEdit?: (poleId: string) => void;
}

export default function PoleListView({ poleList, onPoleClick, isLoading, handleDelete, handleEdit }: PoleListViewProps) {
  const convertedList = poleList?.map((pole) => ({
    data: [pole.pole_name, pole.pole_number],
    id: pole.pole_id,
  }));

  return (
    <Table
      variant="dark"
      headerTitle={["Nom", "Numéro"]}
      bodyData={convertedList}
      emptyMessage="Aucun poteau trouvé"
      onRowClick={(row) => { onPoleClick &&onPoleClick(row.id)}}
      isLoading={isLoading}
      onDeleteRow={handleDelete ? (row) => { handleDelete(row.id)} : undefined}
      onEditRow={handleEdit ? (row) => { handleEdit(row.id)} : undefined}
    />
  );
}
